import { serverTimestamp, auth } from '../firebaseConfig'


function withCreatedDataInfo(object) {
  return Object.assign({ createdAt: serverTimestamp, createdBy: auth.currentUser.uid }, object)
}

function withUpdatedDataInfo(object) {
  delete object.updatedBy
  delete object.updatedAt
  return Object.assign({ updatedAt: serverTimestamp, updatedBy: auth.currentUser.uid, createdAt: serverTimestamp, createdBy: auth.currentUser.uid }, object)
}

export {
  withCreatedDataInfo,
  withUpdatedDataInfo
}